<ng-container *ngIf="agGridParams.value">
  <ng-container [ngSwitch]="agGridParams.value.format_type">
    <ng-container *ngSwitchCase="'images'">
      <app-cell-images [values]="agGridParams.value" class="full-height display-flex"></app-cell-images>
    </ng-container>
    <ng-container *ngSwitchCase="'array'">
      <app-cell-array [values]="agGridParams.value" class="full-height display-flex"></app-cell-array>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <app-source size="20"
                  [enableName]="false"
                  [item]="{icon: agGridParams.value.icon, color: agGridParams.value.color, name: value}"
                  class="full-width">
        <div class="display-flex full-width overflow-hidden">
          <div class="flex-grow text-ellipsis">
            {{ value || '-' | translate }}
          </div>
          <div class="display-flex flex-align-center"
               *ngIf="agGridParams.value.type === 'cell' && !agGridParams.colDef.params.suppressCellDimensionFilter">
            <app-filter-selector
              class="display-inline-flex"
              [selected]="hasFilter() | async"
              (change)="onToggleFilter($event)"></app-filter-selector>
          </div>
        </div>
      </app-source>
    </ng-container>
  </ng-container>
</ng-container>
